import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APP_URLS } from '../../Models/url';
import { CourseService } from '../../services/course.service';
import { UserService } from '../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { MyProfileService } from '../../services/my-profile.service';
import { TenantId } from '../../Models/url';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cart-details',
  templateUrl: './cart-details.component.html',
  styleUrls: ['./cart-details.component.css'],
})
export class CartDetailsComponent implements OnInit {
  showDialogReg = false;
  CartDetails = [];
  TotalCartFee = 0;
  listCount: any;
  CartList = [];
  student_Id: any;
  access_token = '';
  isLoading = false;
  detailRecivedSubscription: Subscription;

  constructor(
    private userSvc: UserService,
    private router: Router,
    private myProfileSvc: MyProfileService,
    public service: CourseService
  ) {
    this.detailRecivedSubscription = this.userSvc
      .getCart()
      .subscribe((data) => {
        if (data) {
          this.ngOnInit();
        }
      });
  }

  ngOnDestroy() {
    this.detailRecivedSubscription.unsubscribe();
  }

  ngOnInit(): void {
    let data = JSON.parse(localStorage.getItem('userDetails'));
    if (data) {
      this.student_Id = data._id;
    }

    if (data != null) {
      this.access_token = data.access_token;
    }
    let dataofcart = localStorage.getItem('cartdata');

    if (dataofcart != null) {
      this.CartList = dataofcart.split(',');
      // this.addtocartCall();
    }

    this.getCart();
  }

  selectCourse(data) {
    this.service.selectCourseById(data.course);
    this.service.senddataToHeader(data.course);
    this.router.navigate(['app/' + data.course.slug]);
  }

  // async addtocartCall(){

  //   let url = APP_URLS.cartmulti;
  //   let payload = {
  //     courseids : this.CartList
  //   }
  //   await this.userSvc.putCallwithHeaders(url,payload).subscribe((res:any)=>{
  //     if(res.suc_arr.length > 0){
  //       // localStorage.removeItem('cartdata')
  //     }
  //   })
  // }

  async getCart() {
    this.isLoading = true;
    if (localStorage.getItem('token') && this.student_Id) {
      let url = APP_URLS.getcart;
      let payload = {};
      await this.userSvc
        .postCallwithHeaders(url, payload)
        .subscribe((res: any) => {
          this.isLoading = false;
          this.listCount = res.listCount;
          this.CartDetails = res.list;
          //  this.userSvc.setCart("cart")
          let total = 0;
          res.list.forEach((x) => {
            total = total + x.course.course_fee_final;
          });
          this.TotalCartFee = total;
        });
    } else {
      let url = APP_URLS.getcart;

      let payload = {
        courseids: this.CartList,
        tenantId: TenantId,
      };
      await this.userSvc.postCall(url, payload).subscribe((res: any) => {
        this.listCount = res.listCount;
        this.CartDetails = res.list;
        // this.userSvc.setCart("cart")
        let total = 0;
        res.list.forEach((x) => {
          total = total + x.course.course_fee_final;
        });
        this.TotalCartFee = total;
        this.isLoading = false;
      });
    }
  }

  removeCart(item) {
    if (localStorage.getItem('token') && this.student_Id) {
      let url = APP_URLS.removefromcart + item.course._id;
      let payload = {
        cartId: item._id,
        courseId: item.course._id,
      };

      this.userSvc.postCallwithHeaders(url, payload).subscribe((res: any) => {
        if (res.respCode) {
          this.userSvc.showSuccess(res.respMessage);
          this.userSvc.setCart('cart');
          this.getCart();
        }
      });
    } else {
      this.CartList.forEach((x, i) => {
        if (x == item.course._id) {
          this.CartList.splice(i, 1);
          let data = this.CartList;
          if (data.length > 0) {
            localStorage.setItem('cartdata', data.toString());
          }
          if (data.length == 0) {
            localStorage.removeItem('cartdata');
          }

          this.userSvc.showSuccess('Course Removed from Cart');
          this.userSvc.setCart('cart');
          this.getCart();
        }
      });
    }
  }

  checkout() {
    // if (this.student_Id) {
    //   this.router.navigate(['/checkout'])
    // }
    // else {
    //   this.userSvc.showError("Please Register or Login");
    //   this.myProfileSvc.setForgotPop('register')
    //   this.showDialogReg = true;
    // }
    if (this.CartDetails.length > 0) {
      this.router.navigate(['app/checkout']);
    } else {
      this.userSvc.showError('No course selected');
    }
  }

  navigateURL(url) {
    this.router.navigate(['app', url]);
  }
}
